import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmsList = _resolveComponent("SmsList")!
  const _component_SmsContent = _resolveComponent("SmsContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SmsList, { onGetSmsDetails: _ctx.getSmsDetails }, null, 8, ["onGetSmsDetails"]),
    _createVNode(_component_SmsContent, {
      selectedData: _ctx.selectedData,
      taskName: _ctx.taskName
    }, null, 8, ["selectedData", "taskName"])
  ]))
}